export default __webpack_public_path__ + "static/media/star.7327c0f4.svg";